import PropTypes from 'prop-types';
import { m } from 'framer-motion';
// components
import TextAnimate from "./TextAnimate";

// ----------------------------------------------------------------------

TextSubAnimate.propTypes = {
  text: PropTypes.string.isRequired,
  variants: PropTypes.object,
  sx: PropTypes.object
};

export default function TextSubAnimate({ text, variants, sx, ...other }) {
  return (
    <TextAnimate
      component={m.h2}
      text={text}
      sx={{
        typography: { xs: 'h4', sm: 'h3', lg: 'h2' },
        // override responsive: el shorthand `typography` reaplica Cormorant+700 en media queries,
        // así que repetimos font/peso por breakpoint para que ganen en todos los tamaños.
        fontFamily: { xs: "'Nunito', sans-serif", sm: "'Nunito', sans-serif", lg: "'Nunito', sans-serif" },
        fontWeight: { xs: 200, sm: 200, lg: 200 },
        fontSize: { xs: '1.05rem', sm: '1.4rem', lg: '2.4rem' }, // un poco más chico que h4/h3/h2
        ...sx
      }}
      {...other}
    />
  );
}
